import $ from "jquery"
import { trace, mobilecheck } from "./../shared/helpers.js"

const Header = {

  onSearchExpand() {
    let $searchForm = $('.header-search-form');
    let $searchInput = $searchForm.find("input");
    let wasExpanded = $("html").hasClass("search-expanded");
    if (wasExpanded) {
      let val = $searchInput.val();
      if (val) {
        $searchForm.submit(); 
      } else {
        $searchInput.focus();
      }
    } else {
      $("html").addClass("search-expanded");
      setTimeout( ()=>{
        $searchInput.focus()
      }, 400);
      // Aria label
      const ariaLabel = document.querySelector("a.search-expand .sr-only")
      if (ariaLabel) {
        const labelSubmit = ariaLabel.dataset.labelSubmit
        if (labelSubmit) {
          ariaLabel.innerHTML = labelSubmit
        }
      }
    }

  },

  onSearchCollapse() {
    let $searchForm = $('.header-search-form');
    let $searchInput = $searchForm.find("input");
    $("html").removeClass("search-expanded");
    $searchInput.val("");
    // Aria label
    const ariaLabel = document.querySelector("a.search-expand .sr-only")
    if (ariaLabel) {
      const labelExpand = ariaLabel.dataset.labelExpand
      if (labelExpand) {
        ariaLabel.innerHTML = labelExpand
      }
    }
  },

  init() {
    // init main menu collapse
    let eventtype = mobilecheck() ? "touchstart" : "click";
    let bodyClickFn = (e)=> {
            
      if (!$("#main-menu").has(e.target).length || $("#main-menu-close").has(e.target).length || $(e.target).attr("id") == "main-menu-close") {
        trace("menu close", eventtype);
        $("html").removeClass("menu-open");
        $("body").off(eventtype, bodyClickFn);
        // Menu tabindex
        const mainMenu = document.getElementById("main-menu")
        if (mainMenu) {
          mainMenu.tabIndex = "-1"
          mainMenu.setAttribute("aria-hidden", "true")
        }
      }
    }
    let menuOpen = ()=> {
      trace("menu open", eventtype);
      $("html").addClass("menu-open");
      $("body").on(eventtype, bodyClickFn);
      // Menu tabindex
      const mainMenu = document.getElementById("main-menu")
      if (mainMenu) {
        mainMenu.tabIndex = "0"
        mainMenu.setAttribute("aria-hidden", "false")
        // set focus on first element
        const list = [...mainMenu.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')]
        if (list.length > 0) {
          setTimeout(() => {
            list[0].focus()
          }, 700)
          
        }
      }
    }
    $('body').on(eventtype, "#main-menu-toggle", (e)=> {
      e.preventDefault();
      if (!$("html").hasClass("menu-open")) {
        menuOpen();
      }
    });

    // header search
    $('body').on(eventtype, ".search-expand", (e)=> {
      e.preventDefault();
      this.onSearchExpand(e);
    });
    $('body').on(eventtype, ".search-collapse", (e)=> {
      e.preventDefault();
      this.onSearchCollapse(e);
    });


  }

}

export default Header;